(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cw-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slides]');
    if (!track) return;
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-dot]'));
    var prev = slider.querySelector('[data-slide-prev]');
    var next = slider.querySelector('[data-slide-next]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function width() { return track.clientWidth || 1; }
    function current() { return Math.round(track.scrollLeft / width()); }
    function goTo(i) {
      var max = track.children.length - 1;
      if (i < 0) i = max;
      if (i > max) i = 0;
      track.scrollTo({ left: i * width(), behavior: reduced ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = current();
      dots.forEach(function (d, n) {
        if (n === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { goTo(n); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; sync(); });
      }
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
    });

    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cw-offer__opts').forEach(function (set) {
    var readout = set.querySelector('[data-opt-readout]');
    if (!readout) return;
    set.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('cw-offer__opt-input')) {
        readout.textContent = e.target.dataset.label || '';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cw-sticky').forEach(function (bar) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 600;
    var dismissed = false;
    var ticking = false;
    var blockerVisible = {};

    function anyBlockerVisible() {
      for (var key in blockerVisible) {
        if (blockerVisible[key]) return true;
      }
      return false;
    }

    function update() {
      ticking = false;
      var pastThreshold = window.scrollY > threshold;
      var show = pastThreshold && !dismissed && !anyBlockerVisible();
      bar.setAttribute('data-visible', show ? 'true' : 'false');
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    var hideSelectors = [];
    if (bar.dataset.hideNearOffer === 'true') hideSelectors.push('.cw-offer');
    if (bar.dataset.hideNearFinal === 'true') hideSelectors.push('.cw-cta');
    if ('IntersectionObserver' in window) {
      hideSelectors.forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        new IntersectionObserver(function (entries) {
          blockerVisible[sel] = entries[0].isIntersecting;
          update();
        }, { threshold: 0.15 }).observe(el);
      });
    }

    var dismissBtn = bar.querySelector('[data-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        dismissed = true;
        update();
      });
    }

    var scrollBtn = bar.querySelector('[data-scroll-to-offer]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        var target = document.querySelector('.cw-offer') || document.body;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
